// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3N4Ia","interest":"styles_interest__1lcjV","icon":"styles_icon__2YFG_","label":"styles_label__NO6L_","iconContainer":"styles_iconContainer__3Ga6r"};